import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CardElement,
  Elements,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { toast } from "react-toastify";
import { APIURL } from "../../redux/action/config";
import { stripePromise } from "../../utils/stripe";

const cardElementOptions = {
  hidePostalCode: true, // the app's own CardField doesn't collect this either
  style: {
    base: {
      fontSize: "16px",
      color: "#181c32",
      "::placeholder": { color: "#a1a5b7" },
    },
  },
};

const PurchaseMembershipForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [name, setName] = useState("");
  const [cardComplete, setCardComplete] = useState(false);
  const [description, setDescription] = useState("");
  const [membership, setMembership] = useState("");
  const [membershipDatas, setMembershipDatas] = useState("");

  const emailID = props?.emailID;
  const nameID = props?.name;
  const userID = props?.userID;

  const [membershipPrice, setMemberShipPrice] = useState();
  const [chooseday, setchooseday] = useState();

  const handleSelectPrice = (e, data) => {
    setchooseday(data);
    setMemberShipPrice(Number(e?.target?.id));
  };

  const [disabled, setDisabled] = useState(false);
  const getMemDetails = (id) => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/membership/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setMembershipDatas(result?.data?.membership);
      })
      .catch((error) => console.log("error", error));
  };

  // Records the purchase against the target customer once a real Stripe
  // subscription exists. subscriptionId is set both at the top level (so
  // future admin-cancel/webhook lookups can find this entry by
  // subscriptionId) and inside the transition history.
  const PurchaseMem = (subscriptionId, transition) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      allowedOrders: membershipDatas?.order_Counts,
      membership_id: membershipDatas?.id,
      placedOrders: 0,
      name: membershipDatas?.name,
      expired: "false",
      subscriptionId,
      transition: [transition],
    });

    var requestOptions = {
      method: "PATCH",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${APIURL}/api/v1/users/purchaseMembership/${userID}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          var myHeaders = new Headers();
          myHeaders.append("Authorization", "Bearer {{jwt}}");
          myHeaders.append("Content-Type", "application/json");
          var raw = JSON.stringify({
            title: "Membership Purchased",
            description: description || "Membership Purchased",
            transition: [transition],
            customer_id: `${userID}`,
            customer_data: `${userID}`,
          });

          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          fetch(`${APIURL}/api/v1/chargesHistory`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
              if (result.status == "success") {
                toast.success("Membership purchased successfully!");
                setTimeout(() => {
                  return (window.location.href = `/edit-customers/${userID}`);
                }, 2000);
              } else {
              }
              setDisabled(false);
            })
            .catch((error) => {
              console.log("error", error);
              setDisabled(false);
            });
        } else {
          toast.error(result?.message);
          setDisabled(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setDisabled(false);
      });
  };

  useEffect(() => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/membership`, requestOptions)
      .then((response) => response.json())
      .then((result) => setMembership(result))
      .catch((error) => console.log("error", error));
  }, []);

  const membershipData = membership?.data?.membership
    ? membership?.data?.membership
    : "";

  const [stripeProducts, setstripeProducts] = useState();
  useEffect(() => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/products`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status == "fail") {
        } else {
          setstripeProducts(result?.data?.Products);
        }
      })
      .catch((error) => console.log("error", error));
  }, []);

  const roadsideMembership = stripeProducts?.[0][`${membershipDatas?.name}`];
  const filteredproductId = roadsideMembership?.filter(
    (val) => val?.type == chooseday
  );

  const authConfig = () => {
    const token = localStorage.getItem("token");
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  };

  const handlerPurchase = async () => {
    if (!stripe || !elements) return;
    setDisabled(true);

    const cardElement = elements.getElement(CardElement);
    const { paymentMethod, error: pmError } = await stripe.createPaymentMethod(
      {
        type: "card",
        card: cardElement,
        billing_details: { name, email: emailID },
      }
    );

    if (pmError) {
      toast.error(pmError.message || "Could not read card details.");
      setDisabled(false);
      return;
    }

    try {
      const customerRes = await axios.post(
        `${APIURL}/api/v1/payments/create-customer`,
        { targetUserId: userID },
        authConfig()
      );
      const customerId = customerRes?.data?.result?.customer?.id;

      await axios.post(
        `${APIURL}/api/v1/payments/create-card`,
        { targetUserId: userID, customerId, paymentMethodId: paymentMethod.id },
        authConfig()
      );

      await axios.post(
        `${APIURL}/api/v1/payments/create-method`,
        { targetUserId: userID, customerId, paymentMethodId: paymentMethod.id },
        authConfig()
      );

      const subRes = await axios.post(
        `${APIURL}/api/v1/payments/create-subscription`,
        {
          targetUserId: userID,
          customerId,
          planId: `${filteredproductId[0]?.productId}`,
          amount: `${membershipPrice}`,
          subType: `${filteredproductId[0]?.type}`,
          paymentMethodId: paymentMethod.id,
        },
        authConfig()
      );

      const subscription = subRes?.data?.result?.subscription;
      const paymentIntent = subscription?.latest_invoice?.payment_intent;
      const paymentIntentStatus = paymentIntent?.status;

      // "message: success" covers both a genuinely completed payment and a
      // pending 3DS challenge (the backend can't tell those apart at create
      // time), so the payment intent's own status has to be checked first.
      if (paymentIntentStatus === "requires_action") {
        toast.error(
          "This card requires additional verification (3D Secure) that only the customer can complete. Ask the customer to purchase or confirm this membership themselves in the app."
        );
        setDisabled(false);
        return;
      }

      if (subRes?.data?.message === "success" && subscription?.id) {
        const amount =
          paymentIntent?.amount_received ??
          paymentIntent?.amount ??
          (membershipPrice ? Number(membershipPrice) * 100 : undefined);
        PurchaseMem(subscription.id, {
          status: "succeeded",
          subscriptionId: subscription.id,
          at: new Date().toISOString(),
          ...(typeof amount === "number" ? { amount } : {}),
        });
        return;
      }

      toast.error(
        subRes?.data?.reason
          ? `Subscription could not be created: ${subRes.data.reason}`
          : "Subscription could not be created. Please try again."
      );
      setDisabled(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Could not process this payment. Please try again."
      );
      setDisabled(false);
    }
  };

  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={props?.modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0 d-flex">
              <div className="text-center">
                <h1 className=" text-primary">Purchase Membership</h1>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form className="pt-4">
                <div className="mb-8">
                  <div className="col-xl-3">
                    <div className="fs-6 fw-bold mt-2 mb-3">
                      <span className="required">Select Membership</span>
                    </div>
                  </div>
                  <select
                    className="form-select form-control form-control-solid"
                    aria-label="Select example"
                    onChange={(e) => {
                      getMemDetails(e.target.value);
                    }}
                  >
                    <option>Select Membership</option>
                    {membershipData
                      ? membershipData?.map((item) => {
                          return <option value={item.id}>{item.name}</option>;
                        })
                      : ""}
                  </select>
                </div>
                <div className="mb-8">
                  <div className="col-12">
                    <div className="fs-6 fw-bold mt-2 mb-3">
                      Choose Membership Plan
                    </div>
                  </div>
                  <div className="row select-plan">
                    <div className="form-check col-4">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id={membershipDatas?.price}
                        onChange={(e) => {
                          handleSelectPrice(e, "year");
                        }}
                      />
                      <label className="form-check-label" htmlFor="yearlyPrice">
                        {membershipDatas?.price
                          ? `$${membershipDatas?.price}`
                          : `$0`}{" "}
                        / Yearly price
                      </label>
                    </div>
                    <div className="form-check col-4">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id={membershipDatas?.priceMonthly}
                        onChange={(e) => {
                          handleSelectPrice(e, "month");
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="monthlyPrice"
                      >
                        {membershipDatas?.priceMonthly
                          ? `$${membershipDatas?.priceMonthly}`
                          : `$0`}{" "}
                        / Monthly price
                      </label>
                    </div>
                    <div className="form-check col-4">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id={membershipDatas?.priceDaily}
                        onChange={(e) => {
                          handleSelectPrice(e, "day");
                        }}
                      />
                      <label className="form-check-label" htmlFor="deilyPrice">
                        {membershipDatas?.priceDaily
                          ? `$${membershipDatas?.priceDaily}`
                          : `$0`}{" "}
                        / Daily price
                      </label>
                    </div>
                  </div>
                </div>
                <div className="mb-8">
                  <div className="col-xl-3">
                    <div className="fs-6 fw-bold mt-2 mb-3"><span className="required">Name on card</span></div>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-solid"
                    name="name"
                    placeholder="Name on card"
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="mb-8">
                  <div className="col-xl-3">
                    <div className="fs-6 fw-bold mt-2 mb-3"><span className="required">Card details</span></div>
                  </div>
                  <div className="form-control form-control-solid" style={{ paddingTop: "14px", paddingBottom: "14px" }}>
                    <CardElement
                      options={cardElementOptions}
                      onChange={(e) => setCardComplete(e.complete)}
                    />
                  </div>
                </div>
                <div className="mb-8">
                  <div className="col-xl-3">
                    <div className="fs-6 fw-bold mt-2 mb-3"><span className="required">Description</span></div>
                  </div>
                  <input
                    type="text"
                    className="form-control form-control-solid"
                    name="description"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              {disabled == true ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handlerPurchase}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  disabled={true}
                >
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Processing...
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handlerPurchase}
                  disabled={
                    !membershipDatas ||
                    !name ||
                    !cardComplete ||
                    !description ||
                    filteredproductId?.[0]?.type == undefined
                  }
                >
                  Pay
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const PurchaseMembership = (props) => (
  <Elements stripe={stripePromise}>
    <PurchaseMembershipForm {...props} />
  </Elements>
);

export default PurchaseMembership;
